import { and } from 'ember-truth-helpers';
import { on } from '@ember/modifier';
import TruncatedText from './truncated-text.gjs';
import styles from './messaging-notification.module.scss';

<template>
  <div
    class="{{styles.component}} {{@type}} messaging-notification"
    data-test-messaging-notification
  >
    {{#if @truncated}}
      <TruncatedText @text={{@message}} data-test-truncated-text />
    {{else}}
      <div class="system-message" data-test-system-message>{{@message}}</div>
    {{/if}}

    {{#if (and @buttonLabel @onButtonClick)}}
      <button
        class="button primary system-message-button"
        type="button"
        {{on "click" @onButtonClick}}
        data-test-system-message-button
      >
        {{@buttonLabel}}
      </button>
    {{/if}}
  </div>
</template>
